/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { OasDocument } from '../../openapi/models/OasDocument';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30ResponseDefinition } from '../../openapi/v3/models/Oas30ResponseDefinition';
import { RenameResponseDefinitionCommand } from './RenameResponseDefinitionCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends RenameResponseDefinitionCommand
 * @class
 */
export class RenameResponseDefinitionCommand_30 extends RenameResponseDefinitionCommand {
    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super(oldName, newName);
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.RenameResponseDefinitionCommand#_nameToReference(java.lang.String)
     * @param {string} name
     * @return {string}
     */
    _nameToReference(name : string) : string {
        return "#/components/responses/" + name;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.RenameResponseDefinitionCommand#_renameResponseDefinition(io.apicurio.datamodels.openapi.models.OasDocument, java.lang.String, java.lang.String)
     * @param {OasDocument} document
     * @param {string} fromName
     * @param {string} toName
     * @return {boolean}
     */
    _renameResponseDefinition(document : OasDocument, fromName : string, toName : string) : boolean {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components) || this.isNullOrUndefined(doc30.components.responses)) {
            return false;
        }
        if(ModelUtils.isDefined(doc30.components.getResponseDefinition(toName))) {
            return false;
        }
        let responseDef : Oas30ResponseDefinition = doc30.components.removeResponseDefinition(fromName);
        responseDef.rename(toName);
        doc30.components.addResponseDefinition(toName, responseDef);
        return true;
    }
}
RenameResponseDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.RenameResponseDefinitionCommand_30";
RenameResponseDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




